import React from "react";
import { Box, Step, StepLabel, Stepper as MuiStepper } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import { VERTIFICATION_METHOD_ENUM } from "@containers/SignUp/constants";
const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: "center",
    margin: "auto",
    display: "flex",
    justifyContent: "flex-start",
    background: "transparent",
  },
  active: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    borderRadius: 30,
    width: "55px",
    height: "50px",
    background: "#69CDAE",
  },
  completed: {
    borderRadius: "30px",
    background: "#69CDAE",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "35px",
    height: "30px",
  },
  normal: {
    width: "35px",
    borderRadius: 30,
    display: "flex",
    color: "white",
    justifyContent: "center",
    alignItems: "center",
    height: "30px",
    background: "#DDDDDD",
  },
  step: {
    "& .MuiStepIcon-root": {
      width: "35px",
      borderRadius: 30,
      height: "30px",
      color: "#DDDDDD",
      "&.MuiStepIcon-active": {
        borderRadius: 30,
        width: "55px",
        height: "50px",
        color: "#69CDAE",
      },
      "&.MuiStepIcon-completed": {
        borderRadius: "30px !important",
        color: "#69CDAE",
        width: "35px",
        height: "30px",
      },
    },
    "& .MuiStepConnector-alternativeLabel": {
      top: 21,
      left: "calc(-50% + 42px)",
      right: "calc(50% + 42px)",
      "& .MuiStepConnector-lineHorizontal": {
        borderTopWidth: 2,
      },
      "& .MuiStepConnector-line": {
        borderColor: "transparent",
      },
      "&.MuiStepConnector-active": {
        top: 30,
      },
    },
  },
  backIcon: {
    cursor: "pointer",
    position: "absolute",
  },
  // activeConnector: {
  //   "& .MuiStepConnector-alternativeLabel": {
  //     "& .MuiStepConnector-line": {
  //       borderColor: "transparent",
  //     },
  //   },
  // },
  // stepLabel: {
  //   "& .MuiStepLabel-label": {
  //     fontSize: "1.25rem",
  //     color: "rgba(248, 164, 53, 0.5)",
  //   },
  //   "& .MuiStepLabel-active": {
  //     fontSize: "1.5rem",
  //     color: "#F8A435",
  //     fontWeight: 500,
  //   },
  // },
}));

export default function Stepper({
  activeStep,
  steps,
  children,
  onGoBack,
  vertificationMethod,
  selectedOption,
  successfulRegistration,
}) {
  const classes = useStyles();

  const CompletedLabel = (props) => {
    const { active, completed, icon } = props;

    if (completed) {
      return (
        <Box className={classes.completed}>
          <img src="/static/svg/Done_round_fill.svg" />
        </Box>
      );
    }
    if (active) {
      return <Box className={classes.active}>{icon}</Box>;
    }
    return <Box className={classes.normal}>{icon}</Box>;
  };

 


  return (
    <>
      {!successfulRegistration ? (
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            position: "relative",
          }}
          width="10%"
          marginLeft="30px"
        >
          {vertificationMethod ===
            VERTIFICATION_METHOD_ENUM.SUCCESSFUL_VERIFICATION ||
          (!selectedOption&&window.location.pathname==="/company-registration") ||
          activeStep === 3 ? null : (
            <span onClick={onGoBack} className={classes.backIcon}>
              <img src="/static/svg/Frame 2651.svg" />
            </span>
          )}
          <MuiStepper
            className={classes.root}
            activeStep={activeStep}
            alternativeLabel
          >
            {steps?.map((step, index) => (
              <Step
                className={clsx({
                  [classes.step]: true,
                })}
                key={index}
              >
                <StepLabel
                  StepIconComponent={CompletedLabel}
                  className={classes.stepLabel}
                ></StepLabel>
              </Step>
            ))}
          </MuiStepper>
        </Box>
      ) : null}
      {children}
    </>
  );
}
